module.exports = __webpack_public_path__ + "img/in-progress.480a60d6.png";